import Suggestions from "../../../extensions/suggestions";
import {createMarkdownExtension} from "../../util/extensions";

export default createMarkdownExtension(Suggestions, {
  serialize(state, node) {
  },
  parse: {
    setup(node) {
    },
    updateDOM(element) {

    },
  }
})
